import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';

@MergeSchema({
    entity: ActivityEntityName.Invoice
})
export class InvoiceAccountMergeData {

    @MergeField()
    _id: string;

    @MergeField()
    name: string;

    @MergeField()
    friendlyName: string;

    @MergeField()
    type: string;

    @MergeField()
    phone: string;

    @MergeField()
    email: string;

    @MergeField()
    contactName: string;

    @MergeField({ hidden: true })
    contactId: string;

    @MergeField()
    taxId: string;

}

export const InvoiceAccountMergeSchema = getSchema(InvoiceAccountMergeData);